import { formatMoney, formatShortDate } from '../util/formatters';
import { hashToBase36 } from '../util/hash';
import { lineItemTotal } from './quoteRollup';
// The point-in-time disclaimer, verbatim from the Sales Desk prototype. Live
// availability is not a hold, so every quote — on screen and in the PDF — carries
// it. This is the single source of truth for the wording.
export const QUOTE_DISCLAIMER = 'Availability may change until requested.';
const QUOTE_WORDMARK = 'Placemakr';
const QUOTE_TITLE = 'Sales Desk Quote';
const toLineItem = (item) => ({
    propertyName: item.propertyName,
    roomTypeName: item.roomTypeName,
    ratePlanName: item.ratePlanName,
    dates: `${formatShortDate(item.arrival)} - ${formatShortDate(item.departure)}`,
    nights: `${item.nights} ${item.nights === 1 ? 'night' : 'nights'}`,
    quantity: `${item.quantity}`,
    price: formatMoney(lineItemTotal(item), item.currency)
});
// Assembles the fully-formatted PDF view model from the current quote state. The
// caller supplies `documentDate` (the impure "now") so this stays a pure
// function of its inputs.
export const buildQuotePdfViewModel = (items, rollup, documentDate) => ({
    header: { wordmark: QUOTE_WORDMARK, title: QUOTE_TITLE, documentDate },
    lineItems: items.map(toLineItem),
    rollup: {
        roomCharges: formatMoney(rollup.roomCharges, rollup.currency),
        taxesAndFees: formatMoney(rollup.taxesAndFees, rollup.currency),
        total: formatMoney(rollup.total, rollup.currency)
    },
    disclaimer: QUOTE_DISCLAIMER
});
// A content-derived filename for the downloaded quote (e.g. quote-1a2b3c.pdf):
// the same quote always yields the same name, and different quotes differ. Only
// the line items, rollup, and disclaimer feed the hash — the header's document
// date is excluded so re-downloading the same quote stays stable.
export const quotePdfFilename = (viewModel) => {
    const { lineItems, rollup, disclaimer } = viewModel;
    const digest = hashToBase36(JSON.stringify({ lineItems, rollup, disclaimer }));
    return `quote-${digest}.pdf`;
};
